import echarts from 'echarts'
import china from 'echarts/map/json/china.json'
const install = function(Vue) {
    Object.defineProperties(Vue.prototype, {
        $chart: {
            get() {
                return {
                    //地图数据
                    mapecharts: function(id, data) {
                        this.chart = echarts.init(document.getElementById(id));
                        this.chart.clear();
                        var geoCoordMap = {};
                        /*获取地图数据*/
                        echarts.registerMap('china', china)
                        var mapFeatures = echarts.getMap('china').geoJson.features;
                        mapFeatures.forEach(function(v) {
                            var name = v.properties.name;
                            geoCoordMap[name] = v.properties.cp;

                        });
                        var convertData = function(data) {
                            var res = [];
                            for (var i = 0; i < data.length; i++) {
                                var geoCoord = geoCoordMap[data[i].name];
                                if (geoCoord) {
                                    res.push({
                                        name: data[i].name,
                                        value: geoCoord.concat(data[i].value),
                                    });
                                }
                            }
                            return res;
                        };
                        const optionData = {
                            tooltip: {
                                padding: 0,
                                enterable: true,
                                transitionDuration: 1,
                                textStyle: {
                                    color: '#000',
                                    decoration: 'none',
                                },
                                formatter: function(params) {
                                    var tipHtml = '';
                                    tipHtml = '<div style="width:280px;height:180px;background:rgba(22,80,158,0.8);border:1px solid rgba(7,166,255,0.7)">' +
                                        '<div style="width:100%;height:40px;line-height:40px;border-bottom:2px solid rgba(7,166,255,0.7);>' +
                                        '<i style="display:inline-block;width:8px;height:8px;background:#16d6ff;border-radius:40px;"></i>' +
                                        '<span style="margin-left:10px;color:#fff;font-size:16px;">' + params.name + '</span>' +
                                        '</div>' +
                                        '<div style="padding:10px 30px; text-align: left;">' +
                                        '<p style="color:#fff;font-size:12px;">' +
                                        '<i style="display:inline-block;width:10px;height:10px;background:#16d6ff;border-radius:40px;margin:0 8px"></i>' +
                                        '用户总数：' +
                                        '<span style="color:#11ee7d;margin:0 6px;">' + params.data.value + '</span>' + '个' +
                                        '</p>' +
                                        '<p style="color:#fff;font-size:12px;">' +
                                        '<i style="display:inline-block;width:10px;height:10px;background:#16d6ff;border-radius:40px;margin:0 8px"></i>' +
                                        '普通会员人数：' +
                                        '<span style="color:#f48225;margin:0 6px;">' + params.data.ordinary + '</span>' + '个' +
                                        '</p>' +
                                        '<p style="color:#fff;font-size:12px;">' +
                                        '<i style="display:inline-block;width:10px;height:10px;background:#16d6ff;border-radius:40px;margin:0 8px"></i>' +
                                        '经济会员人数：' +
                                        '<span style="color:#f4e925;margin:0 6px;">' + params.data.economic + '</span>' + '个' +
                                        '</p>' +
                                        '<p style="color:#fff;font-size:12px;">' +
                                        '<i style="display:inline-block;width:10px;height:10px;background:#16d6ff;border-radius:40px;margin:0 8px"></i>' +
                                        '高级会员人数：' +
                                        '<span style="color:#25f4f2;margin:0 6px;">' + params.data.senior + '</span>' + '个' +
                                        '</p>' +
                                        '<p style="color:#fff;font-size:12px;">' +
                                        '<i style="display:inline-block;width:10px;height:10px;background:#16d6ff;border-radius:40px;margin:0 8px"></i>' +
                                        'Vip会员人数：' +
                                        '<span style="color:#25f4f2;margin:0 6px;">' + params.data.VIP + '</span>' + '个' +
                                        '</p>' +
                                        '</div>' + '</div>';
                                    return tipHtml;
                                }
                            },
                            visualMap: {
                                min: 0,
                                max: 100,
                                text: ['高', '低'],
                                left: '10%',
                                top: 'bottom',
                                calculable: false,
                                orient: 'horizontal',
                                inRange: {
                                    color: ['#dae6fa', '#0150d6']
                                }
                            },
                            series: [{
                                    name: '散点',
                                    type: 'scatter',
                                    coordinateSystem: 'geo',
                                    data: convertData(data),
                                    label: {
                                        normal: {
                                            formatter: '{b}',
                                            position: 'right',
                                            show: true
                                        },
                                        emphasis: {
                                            show: true
                                        }
                                    },
                                    itemStyle: {
                                        normal: {
                                            color: '#fff'
                                        }
                                    }
                                },
                                {
                                    type: 'map',
                                    map: 'china',
                                    geoIndex: 0,
                                    aspectScale: 0.75, //长宽比
                                    showLegendSymbol: false, // 存在legend时显示
                                    label: {
                                        normal: {
                                            show: true
                                        },
                                        emphasis: {
                                            show: false,
                                            textStyle: {
                                                color: '#fff'
                                            }
                                        }
                                    },
                                    roam: false,
                                    itemStyle: {
                                        normal: {
                                            areaColor: '#031525',
                                            borderColor: '#3B5077',
                                        },
                                        emphasis: {
                                            areaColor: '#fab70f'
                                        }
                                    },
                                    animation: false,
                                    data: data
                                },


                            ]
                        };
                        this.chart.setOption(optionData);
                        this.chart.resize();
                    },
                    // 柱状图
                    barechart: function(id, xAxisList, seriesList) {
                        this.chart = echarts.init(document.getElementById(id));
                        this.chart.clear();
                        const optionData = {
                            xAxis: {
                                type: 'category',
                                boundaryGap: true,
                                data: xAxisList
                            },
                            tooltip: {
                                trigger: 'axis'
                            },
                            grid: {
                                top: '13%',
                                left: '3%',
                                right: '4%',
                                bottom: '10%',
                                containLabel: true
                            },
                            yAxis: {
                                type: 'value',
                                name: '数量',
                            },
                            series: [{
                                name: ['访客总数'],
                                type: 'bar',
                                stack: '访客总数',
                                barWidth: '35',
                                data: seriesList
                            }],
                            color: ['#B6A2DE', '#5AB1EE', '#2EC7C9', '#FFB980', '#0BCC61', '#D36C72'],
                        };
                        this.chart.setOption(optionData);
                        this.chart.resize();
                    },
                    // 折线图
                    linkchart: function(id,name, xAxisList, seriesList) {
                        this.chart = echarts.init(document.getElementById(id));
                        this.chart.clear();
                        const optionData = {
                            xAxis: {
                                type: 'category',
                                boundaryGap: true,
                                data: xAxisList
                            },
                            tooltip: {
                                trigger: 'axis'
                            },
                            legend: {
                                data: name
                            },
                            grid: {
                                top: '13%',
                                left: '3%',
                                right: '4%',
                                bottom: '10%',
                                containLabel: true
                            },
                            toolbox: {
                                feature: {
                                    saveAsImage: {}
                                }
                            },
                            yAxis: {
                                type: 'value',
                            },
                            series: seriesList,
                            color: ['#B6A2DE', '#5AB1EE', '#2EC7C9', '#FFB980', '#0BCC61', '#D36C72'],
                        };
                        this.chart.setOption(optionData);
                        this.chart.resize();
                    },
                }
            }
        }
    })
}
export default {
    install
}


// WEBPACK FOOTER //
// ./src/assets/public/myEcharts.js